
<ng-container *ngIf="!isOptionLoading;else Loading">
  <app-nav-header [CompanyID]="CompanyID" [UserID]="UserID" [Liff_ID]="Liff_ID" [title]="'交易資訊'"></app-nav-header>  
          <form class="page__content pageForm" style="width:100%;">
            <div class="row">
                <div class="col-12 mb-4">
                  <p-button label="回到最上方" (onClick)="reset()" styleClass="w-full border-round-lg" [disabled]="editModel.length == 0"
                  ></p-button>
                </div>
              <ng-container *ngIf="editModel.length>0;else noData">
                <p-scroller 
                    #sc [items]="editModel" 
                    [itemSize]="50" 
                    scrollHeight="200px" 
                    styleClass="border-1 surface-border" 
                    [style]="{'width': '100%', 'height': '200px','font-size':'1.3em'}">
                        <ng-template pTemplate="item" let-item let-options="options">
                            <div 
                                class="flex align-items-center p-2" 
                                [ngClass]="{ 'surface-ground': options.odd }" 
                                style="height: 50px;" (click)="GetDetails(item.SaleM.SaleNo)">
                                    {{ item.SaleM.Date }}  {{item.SaleM.TotalAmount}} {{ item.SaleM.isSale == true?"(銷售)":"(退貨)" }}
                            </div>
                        </ng-template>
                </p-scroller>
                <ng-container *ngIf="isLoading">
                  <p-progressBar mode="indeterminate" [style]="{'height': '6px'}"></p-progressBar>
                </ng-container>
                <div *ngIf="!isShow" class="col-12 mt-2 mb-2" style="text-align: center;font-size: 1em;">
                  <p-button label="顯示更多" styleClass="p-button-link" (onClick)="ShowMore()"></p-button>
                </div>
              </ng-container>
              <ng-template #noData>
                <div class="empty-container">
                  <p>目前無交易紀錄</p>
                </div>
              </ng-template>
            </div>
          </form>
          <p-sidebar [(visible)]="showDs" [fullScreen]="true" [baseZIndex]="10000">
            <p-accordion [multiple]="true">
              <p style="margin-left: 10%;font-size: 1em;font-weight: bold;">消費日期: {{showModel.SaleM.Date}}</p>
              <p style="margin-left: 10%;font-size: 1em;font-weight: bold;">門市: {{showModel.SaleM.StoreName}}</p>
              <p-accordionTab header="消費項目">
                <p-table [value]="showModel.SaleDs">
                  <ng-template pTemplate="header">
                      <tr>
                          <th>商品項目</th>
                          <th>金額</th>
                      </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-item>
                      <tr>
                          <td>
                              {{item.ItemName}}
                          </td>
                          <td>
                              <span class="image-text">{{item.ActualPrice}}</span>
                          </td>
                      </tr>
                  </ng-template>
                </p-table>
              </p-accordionTab>
              <p-accordionTab header="消費金額">
                <p-table [value]="showModel.SaleM.Pays">
                  <ng-template pTemplate="header">
                      <tr>
                          <th>支付方式</th>
                          <th>金額</th>
                      </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-pay>
                      <tr>
                          <td>
                              {{pay.PayTypeName}}
                          </td>
                          <td>
                              <span class="image-text">{{pay.Amount}}</span>
                          </td>
                      </tr>
                  </ng-template>
                </p-table>
              </p-accordionTab>
          </p-accordion>
          </p-sidebar>          
</ng-container>
<ng-template #Loading>
<p-progressSpinner ariaLabel="loading" />
</ng-template>